var _excluded = ["children", "className", "addonAfter", "addonBefore", "color", "toFixed"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import React from 'react';
import cx from 'classnames';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { genTextStyles } from "./styles";
export var Text = wrapReactionHook(function (props) {
  var _props$value;
  var children = props.children,
    className = props.className,
    addonAfter = props.addonAfter,
    addonBefore = props.addonBefore,
    color = props.color,
    toFixed = props.toFixed,
    rest = _objectWithoutProperties(props, _excluded);
  var value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : children;
  var prefix = 'form-text';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTextStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var isValidNum = value === undefined || value === null || value === '';
  var numberValue = toFixed && !isValidNum ? Number(value) : undefined;
  return wrapSSR( /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx(prefix, hashId, className),
    style: {
      color: color
    }
  }), addonBefore, toFixed && numberValue !== undefined && !Number.isNaN(numberValue) ? numberValue.toFixed(toFixed) : value !== null && value !== void 0 ? value : '-', addonAfter));
});